/* tslint:disable */
/* eslint-disable */
/**
 * SFTP Permissioning API
 * Here You can find all the endpoints for the Permission API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AssignUsersToAssignmentResponseDto } from '../models';
// @ts-ignore
import { AssignmentEntity } from '../models';
// @ts-ignore
import { CascadeDeleteAssignmentResponseDto } from '../models';
// @ts-ignore
import { CreateAssignmentDto } from '../models';
// @ts-ignore
import { I18nErrorResponseDto } from '../models';
// @ts-ignore
import { UpdateAssignmentDto } from '../models';
/**
 * AssignmentsApi - axios parameter creator
 * @export
 */
export const AssignmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cascade delete an assignment and remove it from all users
         * @param {string} id ID of the assignment to cascade delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cascadeDeleteAssignment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cascadeDeleteAssignment', 'id', id)
            const localVarPath = `/api/v1.0/assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new assignment
         * @param {CreateAssignmentDto} createAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssignment: async (createAssignmentDto: CreateAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAssignmentDto' is not null or undefined
            assertParamExists('createAssignment', 'createAssignmentDto', createAssignmentDto)
            const localVarPath = `/api/v1.0/assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all assignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssignments: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get assignment by ID
         * @param {string} id ID of the assignment to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignmentById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAssignmentById', 'id', id)
            const localVarPath = `/api/v1.0/assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get assignments by business group ID
         * @param {string} businessGroupId Business group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignmentsByBusinessGroupId: async (businessGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessGroupId' is not null or undefined
            assertParamExists('getAssignmentsByBusinessGroupId', 'businessGroupId', businessGroupId)
            const localVarPath = `/api/v1.0/assignments/business-group/{businessGroupId}`
                .replace(`{${"businessGroupId"}}`, encodeURIComponent(String(businessGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search assignments by name
         * @param {string} name Assignment name to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAssignmentByName: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('searchAssignmentByName', 'name', name)
            const localVarPath = `/api/v1.0/assignments/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an assignment
         * @param {string} id ID of the assignment to update
         * @param {UpdateAssignmentDto} updateAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignment: async (id: string, updateAssignmentDto: UpdateAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAssignment', 'id', id)
            // verify required parameter 'updateAssignmentDto' is not null or undefined
            assertParamExists('updateAssignment', 'updateAssignmentDto', updateAssignmentDto)
            const localVarPath = `/api/v1.0/assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssignmentsApi - functional programming interface
 * @export
 */
export const AssignmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssignmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cascade delete an assignment and remove it from all users
         * @param {string} id ID of the assignment to cascade delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cascadeDeleteAssignment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CascadeDeleteAssignmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cascadeDeleteAssignment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new assignment
         * @param {CreateAssignmentDto} createAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssignment(createAssignmentDto: CreateAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssignment(createAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all assignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAssignments(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAssignments(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get assignment by ID
         * @param {string} id ID of the assignment to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssignmentById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignmentById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get assignments by business group ID
         * @param {string} businessGroupId Business group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssignmentsByBusinessGroupId(businessGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignUsersToAssignmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignmentsByBusinessGroupId(businessGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search assignments by name
         * @param {string} name Assignment name to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAssignmentByName(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAssignmentByName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an assignment
         * @param {string} id ID of the assignment to update
         * @param {UpdateAssignmentDto} updateAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssignment(id: string, updateAssignmentDto: UpdateAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssignment(id, updateAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AssignmentsApi - factory interface
 * @export
 */
export const AssignmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssignmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Cascade delete an assignment and remove it from all users
         * @param {string} id ID of the assignment to cascade delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cascadeDeleteAssignment(id: string, options?: any): AxiosPromise<CascadeDeleteAssignmentResponseDto> {
            return localVarFp.cascadeDeleteAssignment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new assignment
         * @param {CreateAssignmentDto} createAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssignment(createAssignmentDto: CreateAssignmentDto, options?: any): AxiosPromise<AssignmentEntity> {
            return localVarFp.createAssignment(createAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all assignments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAssignments(options?: any): AxiosPromise<Array<AssignmentEntity>> {
            return localVarFp.getAllAssignments(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get assignment by ID
         * @param {string} id ID of the assignment to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignmentById(id: string, options?: any): AxiosPromise<AssignmentEntity> {
            return localVarFp.getAssignmentById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get assignments by business group ID
         * @param {string} businessGroupId Business group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignmentsByBusinessGroupId(businessGroupId: string, options?: any): AxiosPromise<AssignUsersToAssignmentResponseDto> {
            return localVarFp.getAssignmentsByBusinessGroupId(businessGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search assignments by name
         * @param {string} name Assignment name to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAssignmentByName(name: string, options?: any): AxiosPromise<Array<AssignmentEntity>> {
            return localVarFp.searchAssignmentByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an assignment
         * @param {string} id ID of the assignment to update
         * @param {UpdateAssignmentDto} updateAssignmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssignment(id: string, updateAssignmentDto: UpdateAssignmentDto, options?: any): AxiosPromise<AssignmentEntity> {
            return localVarFp.updateAssignment(id, updateAssignmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cascadeDeleteAssignment operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiCascadeDeleteAssignmentRequest
 */
export interface AssignmentsApiCascadeDeleteAssignmentRequest {
    /**
     * ID of the assignment to cascade delete
     * @type {string}
     * @memberof AssignmentsApiCascadeDeleteAssignment
     */
    readonly id: string
}

/**
 * Request parameters for createAssignment operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiCreateAssignmentRequest
 */
export interface AssignmentsApiCreateAssignmentRequest {
    /**
     * 
     * @type {CreateAssignmentDto}
     * @memberof AssignmentsApiCreateAssignment
     */
    readonly createAssignmentDto: CreateAssignmentDto
}

/**
 * Request parameters for getAssignmentById operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiGetAssignmentByIdRequest
 */
export interface AssignmentsApiGetAssignmentByIdRequest {
    /**
     * ID of the assignment to retrieve
     * @type {string}
     * @memberof AssignmentsApiGetAssignmentById
     */
    readonly id: string
}

/**
 * Request parameters for getAssignmentsByBusinessGroupId operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiGetAssignmentsByBusinessGroupIdRequest
 */
export interface AssignmentsApiGetAssignmentsByBusinessGroupIdRequest {
    /**
     * Business group ID
     * @type {string}
     * @memberof AssignmentsApiGetAssignmentsByBusinessGroupId
     */
    readonly businessGroupId: string
}

/**
 * Request parameters for searchAssignmentByName operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiSearchAssignmentByNameRequest
 */
export interface AssignmentsApiSearchAssignmentByNameRequest {
    /**
     * Assignment name to search for
     * @type {string}
     * @memberof AssignmentsApiSearchAssignmentByName
     */
    readonly name: string
}

/**
 * Request parameters for updateAssignment operation in AssignmentsApi.
 * @export
 * @interface AssignmentsApiUpdateAssignmentRequest
 */
export interface AssignmentsApiUpdateAssignmentRequest {
    /**
     * ID of the assignment to update
     * @type {string}
     * @memberof AssignmentsApiUpdateAssignment
     */
    readonly id: string

    /**
     * 
     * @type {UpdateAssignmentDto}
     * @memberof AssignmentsApiUpdateAssignment
     */
    readonly updateAssignmentDto: UpdateAssignmentDto
}

/**
 * AssignmentsApi - object-oriented interface
 * @export
 * @class AssignmentsApi
 * @extends {BaseAPI}
 */
export class AssignmentsApi extends BaseAPI {
    /**
     * 
     * @summary Cascade delete an assignment and remove it from all users
     * @param {AssignmentsApiCascadeDeleteAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public cascadeDeleteAssignment(requestParameters: AssignmentsApiCascadeDeleteAssignmentRequest, options?: AxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).cascadeDeleteAssignment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new assignment
     * @param {AssignmentsApiCreateAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public createAssignment(requestParameters: AssignmentsApiCreateAssignmentRequest, options?: AxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).createAssignment(requestParameters.createAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all assignments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public getAllAssignments(options?: AxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).getAllAssignments(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get assignment by ID
     * @param {AssignmentsApiGetAssignmentByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public getAssignmentById(requestParameters: AssignmentsApiGetAssignmentByIdRequest, options?: AxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).getAssignmentById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get assignments by business group ID
     * @param {AssignmentsApiGetAssignmentsByBusinessGroupIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public getAssignmentsByBusinessGroupId(requestParameters: AssignmentsApiGetAssignmentsByBusinessGroupIdRequest, options?: AxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).getAssignmentsByBusinessGroupId(requestParameters.businessGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search assignments by name
     * @param {AssignmentsApiSearchAssignmentByNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public searchAssignmentByName(requestParameters: AssignmentsApiSearchAssignmentByNameRequest, options?: AxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).searchAssignmentByName(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an assignment
     * @param {AssignmentsApiUpdateAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignmentsApi
     */
    public updateAssignment(requestParameters: AssignmentsApiUpdateAssignmentRequest, options?: AxiosRequestConfig) {
        return AssignmentsApiFp(this.configuration).updateAssignment(requestParameters.id, requestParameters.updateAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}
